import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles(() => {
  const theme = useTheme();

  return {
    imgLogos: {
      maxWidth: '245px'
    },
    footer: {
      backgroundColor: '#f5f5f5',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    content: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: '1200px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
      },
    },
    buttons: {
      outline: 'transparent',
      backgroundColor: 'transparent', // Fondo transparente
      boxShadow: 'none', // Sin sombras
      color: '#243C53 !important',
      fontWeight: '700 !important',
      fontSize: '20px !important',
      textTransform: 'capitalize !important',
      '&:hover': {
        color: '#C4E9F1', // Cambia el color del texto al pasar el mouse
        backgroundColor: 'transparent', // Mantener el fondo transparente en hover
      },
    },
    linkedInButton: {
      color: '#243C53 !important',
      textTransform: 'lowercase !important',
      fontWeight: '700 !important',
      fontSize: '20px !important',
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      gap: 5,
      /* marginTop: '15px' */
    },
    linkedinIcon: {
      color: '#1356DA',
      fontSize: '2rem', // Tamaño del icono
    },
    buttonsDiv: {
      display: 'flex',
      gap: '15px',
      alignItems: 'center',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
    logoDiv: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
      [theme.breakpoints.down('lg')]: {
        alignItems: 'center',
      },
    },
    logo: {
      //marginBottom: '10px',
    },
    divider: {
      width: '100%',
      maxWidth: '1200px',
      border: '0.5px solid #1356DA',
      margin: '20px 0',
    },
    bottomText: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: '1200px',
      fontSize: '14px',
      color: '#243C53',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        alignItems: 'center',
        gap: '5px',
      },
    },
    leftText: {
      fontSize: '16px',
      fontWeight: '700',
      textAlign: 'left',
      [theme.breakpoints.down('lg')]: {
        textAlign: 'center',
      },
    },
    rightText: {
      fontSize: '16px',
      fontWeight: '700',
      textAlign: 'right',
      textDecoration: 'none',
      color: '#243C53 !important',
      [theme.breakpoints.down('lg')]: {
        textAlign: 'center',
      },
    },
    mailLink: {
      color: '#243C53 !important',
      textDecoration: 'none',
      fontWeight: '700 !important',
      fontSize: '20px !important',
      display: 'flex',
      alignItems: 'center',
      gap: 5,
      /* marginTop: '15px' */
    },
    linksContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '15px',
      gap: 5
    }
  };
});

export default useStyles;